import api from "api/api";

export const searchUsersByNameQuery = async ({ search }) =>
  await api.get(`/external/dyb/user/search?search=${search}`);
